var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(_vm.isLoggedIn && _vm.hasUser)?_c('layout'):_c('auth-layout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }